import React, { useEffect, useState } from "react";
import { useFormContext } from 'react-hook-form'
import styles from './OccupationInputs.module.scss'
import { Lang } from "../../../types/common-types";
import AccountForm from "../../../types/account-form.types";
import SelectInput from "../../../shared/Inputs/SelectInput/SelectInput";
import { validateString, smartValidateString } from '../../../validate/validators'
import DatePicker from '../../../shared/Inputs/DatePicker/DatePicker'
import { State } from "../../../state-actions-reducers";
import TextInput from "../../../shared/Inputs/TextInput/TextInput";
import PhoneInput from "../../../shared/Inputs/PhoneInput/PhoneInput";
import { OccupationType } from "../../../enums/occupationTypeEnum";

interface OccupationInputsProps {
    lang: Lang
    accountForm: any
}
export default function OccupationInputs({ lang, accountForm }: OccupationInputsProps) {
    const { watch, setValue, formState: { errors } } = useFormContext<State>()
    const state = watch()
    const [focus, setFocus] = useState('')

    useEffect(() => {
        if (!state.occupationType) setValue('occupationType', String(OccupationType.Studying), { shouldDirty: true })
    }, [lang])

    useEffect(() => {
        // учусь
        if (Number(state.occupationType) === OccupationType.Studying) {
            setValue('occupationInstitution', '', { shouldDirty: true })
            setValue('occupationPosition', '', { shouldDirty: true })
            setValue('workPhoneNumbers', [], { shouldDirty: true })
        }
        // работаю
        if (Number(state.occupationType) === OccupationType.Working) {
            setValue('collegeName', '', { shouldDirty: true })
            setValue('collegeProfession', '', { shouldDirty: true })
            setValue('collegeStartedAt', '', { shouldDirty: true })
            setValue('collegeEndedAt', '', { shouldDirty: true })
        }
        // не работаю и не учусь
        if (Number(state.occupationType) === OccupationType.Unemployed) {
            setValue('collegeName', '', { shouldDirty: true })
            setValue('collegeProfession', '', { shouldDirty: true })
            setValue('collegeStartedAt', '', { shouldDirty: true })
            setValue('collegeEndedAt', '', { shouldDirty: true })
            setValue('occupationInstitution', '', { shouldDirty: true })
            setValue('occupationPosition', '', { shouldDirty: true })
            setValue('workPhoneNumbers', [], { shouldDirty: true })
        }
    }, [state.occupationType])

    const ocupationTypeOptions = [
        { value: OccupationType.Studying, label: accountForm.studying },
        { value: OccupationType.Working, label: accountForm.working },
        { value: OccupationType.WorkAndStudy, label: accountForm.workAndStudy },
        { value: OccupationType.Unemployed, label: accountForm.dontStudyOrWork }
    ]
    return <div className="form-group">
        <div className="row">
            <div className="col-12 col-xs-12">
                <h3>{accountForm.stepTwoWorkOrStudyTitle[lang]}</h3>
            </div>
            <div className="col-4 col-xs-12">
                <SelectInput
                    testName={'occupationType'}
                    testErrorName={'error-occupationType'}
                    lang={lang}
                    noOptionsMessage={accountForm.occupationType.placeholder}
                    content={accountForm.occupationType}
                    value={
                        !!state.occupationType
                            ? state.occupationType
                            : String(OccupationType.Studying)
                    }
                    options={ocupationTypeOptions}
                    onChange={data =>
                        setValue('occupationType', data, { shouldDirty: true })
                    }
                    className={styles.input}
                    valid={
                        !errors.occupationType &&
                        validateString(state.occupationType, 30)
                    }
                    required
                />
            </div>
        </div>
        {(Number(state.occupationType) === OccupationType.Working ||
            Number(state.occupationType) === OccupationType.WorkAndStudy) && (
                <div className="row">
                    <div className="col-4 col-xs-12">
                        <TextInput
                            testName="occupationInstitution"
                            testErrorName="error-occupationInstitution"
                            lang={lang}
                            content={accountForm.occupationInstitution}
                            value={state.occupationInstitution}
                            onChange={data =>
                                setValue('occupationInstitution', data, { shouldDirty: true })
                            }
                            valid={
                                state.occupationInstitution.length > 0
                                    ? !errors.occupationInstitution &&
                                    smartValidateString(state.occupationInstitution)
                                    : !errors.occupationInstitution
                            }
                            required
                        />
                    </div>
                    <div className="col-4 col-xs-12">
                        <TextInput
                            testName="occupationPosition"
                            testErrorName="error-occupationPosition"
                            lang={lang}
                            content={accountForm.occupationPosition}
                            value={state.occupationPosition}
                            onChange={data =>
                                setValue('occupationPosition', data, { shouldDirty: true })
                            }
                            valid={
                                state.occupationPosition.length > 0
                                    ? !errors.occupationPosition &&
                                    smartValidateString(state.occupationPosition)
                                    : !errors.occupationPosition
                            }
                            required
                        />
                    </div>
                    <div className="col-4 col-xs-12">
                        <PhoneInput
                            testName="workPhoneNumbers"
                            testErrorName="error-workPhoneNumbers"
                            label={accountForm.workPhoneNumber.label[lang]}
                            lang={lang}
                            numbers={
                                state.workPhoneNumbers.length === 0
                                    ? ['']
                                    : state.workPhoneNumbers
                            }
                            setNumbers={data =>
                                setValue('workPhoneNumbers', data, { shouldDirty: true })
                            }
                            invalidText={accountForm.workPhoneNumber.invalidText[lang]}
                            deleteText={accountForm.removeFieldButton[lang]}
                            addField={accountForm.addFieldButton[lang]}
                            valid={!errors.workPhoneNumbers}
                            required
                        />
                    </div>
                </div>
            )}
        {(Number(state.occupationType) === OccupationType.Studying ||
            Number(state.occupationType) === OccupationType.WorkAndStudy) && (
                <div className="row">
                    <div className="col-4 col-xs-12">
                        <TextInput
                            testName="collegeName"
                            testErrorName="error-collegeName"
                            lang={lang}
                            content={accountForm.collegeName}
                            value={state.collegeName}
                            onChange={data =>
                                setValue('collegeName', data, { shouldDirty: true })
                            }
                            valid={
                                state.collegeName.length > 0
                                    ? !errors.collegeName &&
                                    smartValidateString(state.collegeName)
                                    : !errors.collegeName
                            }
                            required
                        />
                    </div>
                    <div className="col-4 col-xs-12">
                        <TextInput
                            testName="collegeProfession"
                            testErrorName="error-collegeProfession"
                            lang={lang}
                            content={accountForm.collegeProfession}
                            value={state.collegeProfession}
                            onChange={data =>
                                setValue('collegeProfession', data, { shouldDirty: true })
                            }
                            valid={
                                state.collegeProfession.length > 0
                                    ? !errors.collegeProfession &&
                                    smartValidateString(state.collegeProfession)
                                    : !errors.collegeProfession
                            }
                            required
                        />
                    </div>
                    <div className="col-2 col-xs-12">
                        <DatePicker
                            testName="collegeStartedAt"
                            testErrorName="error-collegeStartedAt"
                            lang={lang}
                            accountForm={accountForm}
                            accountFormKey="collegeStartedAt"
                            onChange={data => setValue('collegeStartedAt', data, { shouldDirty: true })}
                            value={state.collegeStartedAt}
                            min={
                                new Date(
                                    new Date().setFullYear(new Date().getFullYear() - 10)
                                )
                            }
                            curr={
                                state.collegeEndedAt
                                    ? new Date(
                                        new Date().setDate(
                                            new Date(state.collegeEndedAt).getDate() - 1
                                        )
                                    )
                                    : new Date()
                            }
                            max={new Date()}
                            focus={focus === 'collegeStartedAt' || undefined}
                            onBlur={() => setFocus('')}
                            valid={!errors.collegeStartedAt}
                            required
                        />
                    </div>
                    <div className="col-2 col-xs-12">
                        <DatePicker
                            testName="collegeEndedAt"
                            testErrorName="error-collegeEndedAt"
                            lang={lang}
                            accountForm={accountForm}
                            accountFormKey="collegeEndedAt"
                            onChange={data => setValue('collegeEndedAt', data, { shouldDirty: true })}
                            value={state.collegeEndedAt}
                            curr={
                                state.collegeStartedAt
                                    ? new Date(
                                        new Date().setDate(
                                            new Date(state.collegeStartedAt).getDate() + 1
                                        )
                                    )
                                    : new Date()
                            }
                            min={
                                new Date(
                                    new Date(
                                        new Date().setFullYear(new Date().getFullYear())
                                    ).setDate(new Date().getDate() + 1)
                                )
                            }
                            max={
                                new Date(
                                    new Date().setFullYear(new Date().getFullYear() + 10)
                                )
                            }
                            focus={focus === 'collegeEndedAt' || undefined}
                            onBlur={() => setFocus('')}
                            valid={!errors.collegeEndedAt}
                            required
                        />
                    </div>
                </div>
            )}
    </div>
}
